import ContractManagement from './ContractManagement.vue'

export default ContractManagement


// WEBPACK FOOTER //
// ./src/pages/ContractManagement/index.js